import React, { useState } from "react";
import { Row, Col, Alert, Form } from "react-bootstrap";
import PropTypes from 'prop-types';
import { useLanguage } from "../context/LanguageContext";
import { TranslatedText } from "../components/TranslatedText";

export const Newsletter = () => {
    const { language } = useLanguage();
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState(null);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email || email.indexOf("@") === -1) {
            setStatus('error');
            setMessage(language === 'en' 
                ? 'Please enter a valid email address' 
                : '请输入有效的电子邮箱地址');
            return;
        }

        try {
            setLoading(true);
            setStatus('sending');

            const response = await fetch('/api/subscribe', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email })
            });

            const data = await response.json();
            if (response.ok) {
                setStatus('success');
                setMessage(data.message || 
                    (language === 'en' 
                        ? 'You have been successfully subscribed!' 
                        : '您已成功订阅！'));
                setEmail('');
            }
            else {
                setStatus('error');
                setMessage(data.message || 
                    (language === 'en' 
                        ? 'Something went wrong. Please try again later.' 
                        : '出现问题。请稍后再试。'));
            }
        } catch(error) {
            console.error('Error subscribing to newsletter:', error);
            setStatus('error');
            setMessage(language === 'en' 
                ? 'Failed to subscribe. Please try again later.' 
                : '订阅失败。请稍后再试。');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="newsletter-wrapper">
            <div className="newsletter-bx">
                <Row>
                    <Col xs={12}>
                        <h3><TranslatedText textKey="subscribeNewsletter" /></h3>
                    </Col>
                    <Col xs={12}>
                        {status === 'sending' && (
                            <Alert variant='info'>
                                <TranslatedText textKey="sending" />
                            </Alert>
                        )}
                        {status === 'error' && <Alert variant='danger'>{message}</Alert>}
                        {status === 'success' && <Alert variant='success'>{message}</Alert>}
                    </Col>
                    <Col xs={12}>
                        <Form onSubmit={handleSubmit}>
                            <div className="email-input-container">
                                <input
                                    type="email"
                                    value={email}
                                    placeholder={language === 'en' ? "Email Address" : "电子邮箱"}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="submit-btn-container">
                                <button type="submit" disabled={loading}>
                                    {loading ? <TranslatedText textKey="submitting" /> : <TranslatedText textKey="submit" />}
                                </button>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

Newsletter.propTypes = {};